"use client";

const SHAFT_PATH = "M4 12h15";
const HEAD_PATH = "M13 6l6 6-6 6";

/**
 * Previous/next buttons for the testimonial carousel. The buttons are never
 * disabled because the carousel loops.
 */
export function CarouselControls({
  onNext,
  onPrevious,
}: {
  onNext: () => void;
  onPrevious: () => void;
}) {
  return (
    <div className="testimonials2-nav">
      <button
        aria-label="Previous testimonial"
        className="testimonials2-nav-button testimonials2-nav-button--previous"
        onClick={onPrevious}
        type="button"
      >
        <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
          <path d={SHAFT_PATH} />
          <path d={HEAD_PATH} />
        </svg>
      </button>
      <button
        aria-label="Next testimonial"
        className="testimonials2-nav-button"
        onClick={onNext}
        type="button"
      >
        <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
          <path d={SHAFT_PATH} />
          <path d={HEAD_PATH} />
        </svg>
      </button>
    </div>
  );
}
